'use client';
import React from 'react';

export const useIsFirstRenderRef = () => {
  const isFirstRender = React.useRef(true);
  React.useEffect(() => {
    isFirstRender.current = false;
  }, []);
  return isFirstRender;
};
